import { BlotterType } from 'models/blotters/BlotterType';
import { IBlotterItem } from 'models/IBlotterItem';
import type { ApiError } from 'utils/http/apiErrorHelper';

export type TradeCancellationsActions =
  | TradeCancellationWorkflowInit
  | TradeCancellationWorkflowAborted
  | TradeCancellationWorkflowCompleted
  | TradeCancellationRequested
  | TradeCancelled
  | TradeCancellationRejected
  | TradeCancellationFailed;

export function tradeCancellationWorkflowInit(tradeId: string, blotterItem: IBlotterItem, blotterType: BlotterType) {
  return { type: 'TRADE_CANCELLATION_WORKFLOW_INIT' as const, tradeId, blotterItem, blotterType };
}
export type TradeCancellationWorkflowInit = ReturnType<typeof tradeCancellationWorkflowInit>;

export function tradeCancellationWorkflowAborted(tradeId: string) {
  return { type: 'TRADE_CANCELLATION_WORKFLOW_ABORTED' as const, tradeId };
}
export type TradeCancellationWorkflowAborted = ReturnType<typeof tradeCancellationWorkflowAborted>;

export function tradeCancellationWorkflowCompleted(tradeId: string) {
  return { type: 'TRADE_CANCELLATION_WORKFLOW_COMPLETED' as const, tradeId };
}
export type TradeCancellationWorkflowCompleted = ReturnType<typeof tradeCancellationWorkflowCompleted>;

export function tradeCancellationRequested(tradeId: string, isin?: string) {
  return { type: 'TRADE_CANCELLATION_REQUESTED' as const, tradeId, isin };
}
export type TradeCancellationRequested = ReturnType<typeof tradeCancellationRequested>;

export function tradeCancelled(tradeId: string, productId?: string) {
  return { type: 'TRADE_CANCELLED' as const, tradeId, productId };
}
export type TradeCancelled = ReturnType<typeof tradeCancelled>;

export function tradeCancellationRejected(tradeId: string, error?: ApiError) {
  return { type: 'TRADE_CANCELLATION_REJECTED' as const, tradeId, error };
}
export type TradeCancellationRejected = ReturnType<typeof tradeCancellationRejected>;

export function tradeCancellationFailed(tradeId: string) {
  return { type: 'TRADE_CANCELLATION_FAILED' as const, tradeId };
}
export type TradeCancellationFailed = ReturnType<typeof tradeCancellationFailed>;
